import { authLogout } from 'logic/auth';

export const Logout = {
  controller($ngRedux) {
    'ngInject';

    return {
      $onInit() {
        $ngRedux.dispatch(authLogout());
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/containers/Logout.js